import {createSelector} from 'reselect';
import {getSubLocationsCountMapHelper} from '../../utils/location-helper';

export const getLocationTree = state => state.locationTree;

export const getIsLocationsTreeLoading = createSelector(
  getLocationTree,
  locationTree => locationTree.isFetching
);

export const getIsLocationsLoadingError = createSelector(
  getLocationTree,
  locationTree => locationTree.error
);

export const getLocationsTreeNodes = createSelector(
  getLocationTree,
  getIsLocationsTreeLoading,
  getIsLocationsLoadingError,
  (locationTree, isLoading, isError) => (isLoading || isError ? null : locationTree.allNodes)
);

export const hasLocationsTreeNodes = createSelector(
  getLocationsTreeNodes,
  locationTreeNodes => locationTreeNodes && locationTreeNodes.some(d => d.parentId !== null)
);

export const getLocationsTreeNodesDictionary = createSelector(
  getLocationTree,
  locationTree => locationTree.nodesDictionary
);

export const getSubLocationCountsMap = createSelector(
  getLocationsTreeNodesDictionary,
  getLocationsTreeNodes,
  (nodesDictionary, allNodes) => getSubLocationsCountMapHelper(nodesDictionary, allNodes)
);
